
import DataGrid, { Paging, Column, Pager } from 'devextreme-react/data-grid';
import { useTranslation } from 'react-i18next'

const DataTable = (props) => {
  const { t } = useTranslation(['customer-user', 'common'])
  let { dataSource } = props // STATE
  let { onEdit, onDelete } = props // ACTION

  return (<div className="">
    <DataGrid
      dataSource={dataSource}
      keyExpr="id"
      showBorders={true}
      columnAutoWidth={true}
      hoverStateEnabled={true}
    >
      <Paging defaultPageSize={10} />
      <Pager
        showInfo={true}
        showPageSizeSelector={true}
        allowedPageSizes={[10, 25, 50]}
      />
      <Column dataField="cust_name" caption={t('customer_name')} />
      <Column dataField="shipto_name" caption={t('branch')} />
      <Column dataField="username" caption={t('username')} />
      <Column dataField="created_date" caption={t('creation_date')} />
      <Column dataField="status_name" caption={t('status')} />
      <Column
        fixed={true}
        caption={t('edit_delete')}
        type="buttons"
        alignment="center"
        width={90}
        buttons={[
          {
            hint: t('common:edit'),
            icon: "fa fa-pencil-square-o",
            visible: true,
            onClick: (e) => {
              e.cancel = "true"
              onEdit(e.row.data)
            }
          },
          {
            hint: t('common:delete'),
            icon: "trash",
            visible: true,
            onClick: (e) => {
              e.cancel = "true"
              let data = e.row.data
              onDelete(data)
            }
          }
        ]} />
    </DataGrid>
  </div>
  )
}

export default DataTable